<div class="mb-2" id="workflowWidgetContainer" *ngIf="showWorkflowWidget"></div>
<div id="routingHistory" [innerHtml]="routingHistoryString" *ngIf="showRoutingHistory"></div>